import { Box, Divider, Modal, Skeleton, Typography, Slide, Button, Avatar } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';
import { Link } from 'react-scroll';

export const MList = ({ divID, navFeature, open, setOpen, loader, tools, redirectHandler, HandleClickTools, handleClickContactUs }) => {
    return (
        <Modal open={open}  
            onClose={()=>setOpen(false)}
            sx={{borderColor:'none !important'}}
            BackdropProps={{style: { backgroundColor: 'transparent', borderColor:'none !important' } }}
            className="noutlined"
        >
            <Slide in={open} direction="right" className="noutlined">
                <Box position="absolute" top={76} height="100%" width="100%" bgcolor="#FFFFFF" py="24px" >
                    <Box height="100%" width="100%" display="flex" flexDirection="column" gap="16px">
                        <Box onClick={redirectHandler} component={Button} minHeight="44px" width="100%" display="flex" justifyContent="space-between" alignItems="center" px="24px">
                            <Typography color="#292C2F" fontWeight={600} fontSize={12} lineHeight="14.4px" letterSpacing="-0.75%">Personal</Typography>
                            <KeyboardArrowRight sx={{height:20, width:20}}/>
                        </Box>
                        <Box minHeight="44px" width="100%" display="flex" justifyContent="space-between" alignItems="center" px="24px">
                            <Typography borderBottom="2px #003F2E solid" color="#292C2F" fontWeight={600} fontSize={12} lineHeight="14.4px" letterSpacing="-0.75%">Business</Typography>
                        </Box>
                        <Divider sx={{height:'4px', bgcolor:'#E7E8EA'}}/>
                        <Box maxHeight="298px" width="100%" className="overflowY cstmscroll">
                            <Box width="100%" display="flex" flexDirection="column">
                            {loader ?
                                (['', '', '', ''].map((v,k) => (
                                    <Box key={k} display="flex" flexDirection="column" gap="8px" py="6px">
                                        <Box fontWeight={400} fontSize={14} lineHeight="23px" color="#333333">
                                            <Skeleton variant="text" width="120px" height="30px" />
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap="8px">
                                            {['','',''].map((d,k) => (
                                                <Box key={k} display="flex" alignItems="center" gap="12px" className="c-pointer"
                                                    minHeight="48px" minWidth="164px" p="12px">
                                                    <Skeleton variant="rectangular" width="24px" height="24px" sx={{borderRadius:'6px'}}/>
                                                    <Skeleton variant="text" width="100px" height="24px" />
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>

                                )))
                            :
                                (tools.map((v,k) => (
                                    <Box width="100%" key={k}>
                                        <Box width="100%" minHeight="45px" display="flex" alignItems="center" bgcolor="#F7F8F8" px="24px">
                                            <Typography fontWeight={600} fontSize={11} lineHeight="13.2px" letterSpacing="-0.75%" color="#5B6167">{v.name}</Typography>
                                        </Box>
                                        {v.tools.map((d,i) => (
                                            <Box onClick={() => HandleClickTools(d)} key={i} width="100%" minHeight="45px" display="flex" justifyContent="space-between" alignItems="center" bgcolor="#FFFFFF" px="24px">
                                                <Box display="flex" alignItems="center" gap="12px">
                                                    <Avatar src={JSON.parse(d.logo)} variant="square" alt={JSON.parse(d.logo)} sx={{height:20, width:20}} />
                                                    <Typography fontWeight={600} fontSize={11} lineHeight="13.2px" letterSpacing="-0.75%" color="#5B6167">{d.name}</Typography>
                                                </Box>
                                                <KeyboardArrowRight sx={{height:20, width:20}}/>
                                            </Box>
                                        ))}
                                    </Box>

                                )))
                            }
                            </Box>
                        </Box>
                        <Divider sx={{height:'4px', bgcolor:'#E7E8EA'}}/>
                        <Box minHeight="233px" width="100%">
                            <Box height="100%" width="100%" display="flex" flexDirection="column" px="24px">
                                {navFeature.map((v,k) =>(
                                    <Link onClick={()=>handleClickContactUs(v.to)} key={k} smooth={true} to={v.to} offset={-76} duration={500}
                                        style={{minHeight:'32px', display:"flex", alignItems:'center'}} className={`c-pointer call-${v.to}`}
                                    >
                                        <Typography 
                                            sx={{
                                                color:'#292C2F',
                                                fontWeight:divID === v.to ? 600 : 400,
                                                fontSize:14,
                                                lineHeight:'14.4px',
                                                letterSpacing:'-0.75%'
                                            }}
                                        >
                                            {v.name}
                                        </Typography>
                                    </Link>
                                ))}
                            </Box>
                        </Box>
                        <Box minHeight="30px"></Box>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    )
}